import {
  PromotionRewardItemUpdateRequestType,
  PromotionRewardItemUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePromotionRewardItemUpdate = (promotionRewardItemId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PromotionRewardItemUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `promotion-reward-items/${promotionRewardItemId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PromotionRewardItemUpdateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Promotions],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PromotionRewardItems],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.PromotionRewardItems,
          promotionRewardItemId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
